import jQuery from 'jquery';
import config from '_config';

var utils = {};

/** Checks if the user is browsing from a mobile device
 * 
 * @param array maxScreenSize (provide an array with [width,height] to check for max screen size also, this is optional)
 * 
 * @returns bool (returns true if it is a mobile device, or false otherwise)
 */
utils.isMobileDevice = function(maxScreenSize) {
    let isMobile = false; 

    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
        isMobile = true;
    }

    console.log(typeof maxScreenSize);
    if (typeof maxScreenSize == 'object') {
        console.log('here');
        if (window.innerWidth < maxScreenSize[0]) isMobile = true;
        if (maxScreenSize.length > 0 && window.innerHeight < maxScreenSize[1]) isMobile = true;
    }

    return isMobile;
}

/** Set a cookie from the front end
 * 
 * @param string cname      (the name of the cookie)
 * @param string cvalue     (the value of the cookie)
 * @param string exseconds  (the expiry time of the cookie in seconds)
 * 
 */
utils.setCookie = function(cname, cvalue, exseconds) {
    //(exdays*24*60*60*1000)
    var d = new Date();
    d.setTime(d.getTime() + exseconds);
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/** Validate a string as a valid url
 * 
 * @param string url (the string to validate)
 * 
 * @returns bool (returns either true, if the string is a valid url, or false otherwise)
 */
utils.validateUrl = function(url) {
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(url);
}

/** Pad a number with a preceeding zero, used for the second to readeable converter
 *
 */
utils.pad = function(num) {
    return ("0" + num).slice(-2);
}

/** Convert an integer of seconds to a readable version
 *
 */
utils.hhmmss = function(secs) {
    let minutes = Math.floor(secs / 60),
        hours;

    secs = secs%60;
    hours = Math.floor(minutes/60)
    minutes = minutes%60;
    
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

/** Define an object path
 * 
 */
utils.defineObjectPath = function(object, pathArray, finalValue) {
      // pathArray: array(options, dynamicQueries)
    let temp = object,
        prev = null;
  
    for (let i = 0; i < pathArray.length; i++) {
        if (typeof temp[pathArray[i]] == 'undefined') {
            temp[pathArray[i]] = {};
            prev = temp;
            temp = temp[pathArray[i]];
        } else {
            if (typeof temp[pathArray[i]] === 'object') {
              prev = temp;
              temp = temp[pathArray[i]];
            } else console.error('nem objektum');
        }
    }
  
    prev[pathArray[pathArray.length - 1]] = finalValue;
    return object;
}

/** Checks if a variable is a jsFunction type object
 * 
 * @param object variable (the variable to check)
 * 
 * @returns bool (returns true if it is a jsFunction type object, or false otherwise)
 */
utils.isJsFunction = function(variable) {
    if (!utils.isObject(variable)) return false;

    if (typeof variable.function == 'undefined') return false;
    else if (typeof variable.function != 'function') {
        variable.function = utils.getFunction(variable.function);
        if (typeof variable.function != 'function') return false;
    }

    if (typeof variable.parameters == 'undefined') variable.parameters = [];

    return variable;
}
  

/** Create an md5 hash from a string
 * 
 * @param string s (the string to use)
 */
utils.MD5 = function(s){
      function L(k,d){return(k<<d)|(k>>>(32-d))}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H)}if(I|d){if(x&1073741824){return(x^3221225472^F^H)}else{return(x^1073741824^F^H)}}else{return(x^F^H)}}function r(d,F,k){return(d&F)|((~d)&k)}function q(d,F,k){return(d&k)|(F&(~k))}function p(d,F,k){return(d^F^k)}function n(d,F,k){return(F^(d|(~k)))}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F)}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F)}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F)}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F)}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]| (G.charCodeAt(H)<<d));H++}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2)}return k}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x)}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128)}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128)}}}return d}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g)}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase()
  };
  
/** PHP array_unique version
 * 
 * @param Array arr
 */
utils.array_unique = function(arr) {
    arr = arr.reverse().filter(function (e, i, arr) {
        return arr.indexOf(e, i+1) === -1;
    }).reverse();

    return arr;
}

/** Get a function based on a string
 * 
 * @param string funcPath (the string to use to fetch the function)
 * @param object base     (optional, where to start looking for the function, defaults to the global window variable)
 */
utils.getFunction = function(funcPath, base) {
    let originalPath = funcPath;

    if (typeof base == 'undefined') base = _global.global;

    if (funcPath === null) return null;

    var value = funcPath.split(".");
    for (var i=0;i<value.length;i++) {
        console.log(value[i]);
        if (typeof base[value[i]] == 'undefined') {
            console.error("Can't find function [" + originalPath + "], maybe you forgot to make it global? Use _global.makeGlobal to make this function global in the place where you defined it!");
            return null;
        }
        base=base[value[i]];
    }

    return base;
}

/** Scroll the page animated
 * 
 */
utils.scrollpageTo = function(selector, container, duration, autoduration, elem) {
    if (typeof container === 'undefined' || container == null) container='html, body';
    if (typeof duration === 'undefined') duration = 0;
    else if (duration == 'auto')
    {
        if (typeof autoduration === 'undefined') autoduration=2;
        if (typeof elem === 'undefined') duration = 0;
        else {
            duration=jQuery(selector).offset().top - jQuery(elem).offset().top;
            if (duration < 0) duration = duration * (-1);
            duration=duration*autoduration;
            console.log(duration);
        }
    }

    jQuery(container).animate({
        scrollTop: jQuery(selector).offset().top
    }, duration);
}

/** Calculate the size of an object
 * 
 */
utils.objectSize = function(obj) {
    let size = 0,
        key;
    
    for (key in obj)
    {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
}

/** Evaluate a string to a boolean
 * 
 * @param string strvalue (the string to evaluate)
 * 
 */
utils.evBool = function(strvalue) {
    if (strvalue === undefined) return false;

    if (typeof strvalue === 'boolean') return strvalue;
    else if (typeof strvalue === 'string') {
        if ((strvalue.toLowerCase() == 'true') || (strvalue == '1')) return true;
        else return false;
    } else if (typeof strvalue === 'integer')
    {
        if (strvalue == 0) return false;
        else return true;
    } else return false;
}

/** Redirect function for guid
 * 
 */
utils.uniqid = function() {
    return utils.guid();
}

/** Generate a series 4 unique id
 * 
 */
utils.guid = function() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
  
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
}

/** Test if a string is a valid JSON string
 * 
 * @param string data (the string to test)
 * 
 */
utils.testIfJson = function(data) {
    let dataArray=null;
    try
    {
        dataArray = JSON.parse(data);
    } catch(e) {
        dataArray = false;
    }
  
    return dataArray;
  }
  
  /** Php equivalent of stripslahes
   * 
   * @param string str (the string to use)
   * 
   */
  utils.stripslashes = function(str) {
    //       discuss at: http://phpjs.org/functions/stripslashes/
    //      original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    //      improved by: Ates Goral (http://magnetiq.com)
    //      improved by: marrtins
    //      improved by: rezna
    //         fixed by: Mick@el
    //      bugfixed by: Onno Marsman
    //      bugfixed by: Brett Zamir (http://brett-zamir.me)
    //         input by: Rick Waldron
    //         input by: Brant Messenger (http://www.brantmessenger.com/)
    // reimplemented by: Brett Zamir (http://brett-zamir.me)
    //        example 1: stripslashes('Kevin\'s code');
    //        returns 1: "Kevin's code"
    //        example 2: stripslashes('Kevin\\\'s code');
    //        returns 2: "Kevin\'s code"
  
    return (str + '')
      .replace(/\\(.?)/g, function(s, n1) {
        switch (n1) {
          case '\\':
            return '\\';
          case '0':
            return '\u0000';
          case '':
            return '';
          default:
            return n1;
        }
      });
}

/** Get dom value of a dom or jQuery element
 * 
 * @param mixed e (either a javascript Dom object, or a jQuery object)
 * 
 */
utils.getDOMValue = function(e) {
    if (!e instanceof jQuery) e=jQuery(e);

    if (e.is("input"))
    {
        return e.val();
    } else if (e.is('select'))
    {
        return e.val();
    } else if (e.is('textarea'))
    {
        return e.val();
    } else if (e.is('div'))
    {
        if (e.hasClass('picker')) return e.data('object').getValue();
    }
}

/** Javascript equivalent of PHP htmlspecialchars_decode
 * 
 */
utils.htmlspecialchars_decode = function(string, quote_style) {
    //       discuss at: http://phpjs.org/functions/htmlspecialchars_decode/
    //      original by: Mirek Slugen
    //      improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    //      bugfixed by: Mateusz "loonquawl" Zalega
    //      bugfixed by: Onno Marsman
    //      bugfixed by: Brett Zamir (http://brett-zamir.me)
    //      bugfixed by: Brett Zamir (http://brett-zamir.me)
    //         input by: ReverseSyntax
    //         input by: Slawomir Kaniecki
    //         input by: Scott Cariss
    //         input by: Francois
    //         input by: Ratheous
    //         input by: Mailfaker (http://www.weedem.fr/)
    //       revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // reimplemented by: Brett Zamir (http://brett-zamir.me)
    //        example 1: htmlspecialchars_decode("<p>this -&gt; &quot;</p>", 'ENT_NOQUOTES');
    //        returns 1: '<p>this -> &quot;</p>'
    //        example 2: htmlspecialchars_decode("&amp;quot;");
    //        returns 2: '&quot;'
  
    var optTemp = 0,
        i = 0,
        noquotes = false;
    if (typeof quote_style === 'undefined') {
        quote_style = 2;
    }
    string = string.toString()
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
    var OPTS = {
        'ENT_NOQUOTES': 0,
        'ENT_HTML_QUOTE_SINGLE': 1,
        'ENT_HTML_QUOTE_DOUBLE': 2,
        'ENT_COMPAT': 2,
        'ENT_QUOTES': 3,
        'ENT_IGNORE': 4
    };
    if (quote_style === 0) {
        noquotes = true;
    }
    if (typeof quote_style !== 'number') { // Allow for a single string or an array of string flags
        quote_style = [].concat(quote_style);
        for (i = 0; i < quote_style.length; i++) {
        // Resolve string input to bitwise e.g. 'PATHINFO_EXTENSION' becomes 4
        if (OPTS[quote_style[i]] === 0) {
            noquotes = true;
        } else if (OPTS[quote_style[i]]) {
            optTemp = optTemp | OPTS[quote_style[i]];
        }
        }
        quote_style = optTemp;
    }
    if (quote_style & OPTS.ENT_HTML_QUOTE_SINGLE) {
        string = string.replace(/&#0*39;/g, "'"); // PHP doesn't currently escape if more than one 0, but it should
        // string = string.replace(/&apos;|&#x0*27;/g, "'"); // This would also be useful here, but not a part of PHP
    }
    if (!noquotes) {
        string = string.replace(/&quot;/g, '"');
    }
    // Put this in last place to avoid escape being double-decoded
    string = string.replace(/&amp;/g, '&');

    return string;
}

/** Test if the input element is an Array object
 * 
 * @param mixed a (the input element to test)
 * 
 */
utils.isArray = function(a) {
    return (!!a) && (a.constructor === Array);
}

/** Test if the input element is an Object
 * 
 * @param mixed a (the input element to test)
 * 
 */
utils.isObject = function(a) {
    return (!!a) && (a.constructor === Object);
}

/** Parse a number
 * 
 */
utils.parseNumber = function(number) {
    console.log("Parsing " , number);
    number = number.replace(/,/g, "");
    console.log("To ", number);
    console.log("Returning ", parseFloat(number));
    return parseFloat(number);
}

/** Get the base url of the page
 * 
 */
utils.getBaseUrl = function() {
    return config.siteUrl + config.languageCode + "/";
}
  
  
  

  
/* Do not know how to add these, have to check


  
  (function( $ ) {
      $.fn.pop = function() {
          var top = this.get(-1);
          this.splice(this.length-1,1);
          return top;
      };
  
      $.fn.shift = function() {
          var bottom = this.get(0);
          this.splice(0,1);
          return bottom;
      };
  })( jQuery );

Array.prototype.clean = function(deleteValue) {
    for (var i = 0; i < this.length; i++) {
      if (this[i] == deleteValue) {
        this.splice(i, 1);
        i--;
      }
    }
    return this;
  }; 

 Object.size = function(obj) {
      var size = 0, key;
      for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
      }
      return size;
  };
  
*/


export default utils;